module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Book Description")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("Dr. Shona Taylor, a specialist in environmental medicine, discovers that a mysterious epidemic is killing the entire population of colony worlds. With the help of her special menagerie, including a cat that can detect environmental hazards, a dog whose system can synthesize vaccines, and an intelligent alien named Chirwl, Shona is determined to stop the epidemic in its tracks, but the people causing the epidemic have set her up to take the blame, spreading the rumor that she is an Angel of Death. Can she find a cure before the disease kills again and puts her and her menagerie in danger?")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Exciting… enjoyable space adventure… Taylor’s Ark is fun and well-crafted, with a heroine you’ll enjoy rooting for!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_vm._v("– Aboriginal SF")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0